export default __webpack_public_path__ + "static/aayushi2-dab139caa67b2fe6c10586538d89912d.jpg";